import { HTTP_REQUEST_TYPE, FUEL_SUPPLIER_API } from "../../constants/api";
import { IAddFuelSupplierRequest } from "../../interfaces/fuelSupplier";
import { sendHttpRequest } from "../api";

const getFuelSuppliers = async (isCX: boolean = true, searchQuery?: string) => {
  const getFuelSuppliersItem = async (apiPath: string, searchQuery?: string) => {
    const payload = {
      ...(searchQuery && { q: searchQuery }),
    };

    const [, resp] = await sendHttpRequest(
      HTTP_REQUEST_TYPE.get,
      apiPath,
      payload
    );

    const [isSucceed, detail, respData] = handleRequestData(resp);
    return [isSucceed, detail, respData?.data || []];
  };

  // Bekol API not integrated yet for fuel suppliers
  const apiPath = isCX ? FUEL_SUPPLIER_API.GET_FUEL_SUPPLIERS : "";
  return getFuelSuppliersItem(apiPath, searchQuery);
};

const postCreateNewSupplier = async (addNewSupplierRequest :IAddFuelSupplierRequest) => {
    const [, resp] = await sendHttpRequest(
        HTTP_REQUEST_TYPE.post,
        FUEL_SUPPLIER_API.POST_SUPPLIER_ADD,
        {
            ...addNewSupplierRequest
        }
    );
    return resp;
};

const deactivateFuelSupplier = async (supplierId: string, userId: string) => {
    const [, resp] = await sendHttpRequest(
        HTTP_REQUEST_TYPE.put,
        `${FUEL_SUPPLIER_API.DEACTIVATE_SUPPLIER}/${supplierId}/state`,
        {
          state: 1,
          updatedBy: userId
        }
    );
    return resp;
};

const activateFuelSupplier = async (supplierId: string, userId: string) => {
    const [, resp] = await sendHttpRequest(
        HTTP_REQUEST_TYPE.put,
        `${FUEL_SUPPLIER_API.ACTIVATE_SUPPLIER}/${supplierId}/state`,
        {
          state: 0,
          updatedBy: userId
        }
    );
    return resp;
};

const updateFuelSupplier = async (supplierId: string, updateData: IAddFuelSupplierRequest) => {
    const [, resp] = await sendHttpRequest(
        HTTP_REQUEST_TYPE.put,
        `${FUEL_SUPPLIER_API.UPDATE_SUPPLIER}/${supplierId}`,
        {
            ...updateData
        }
    );
    return resp;
};

// Handles response data following the same pattern as carReportEmailsAPI
const handleRequestData = (resp: any): [boolean, string, any] => {
  const isSucceed = resp?.success === true;
  const detail = resp?.message || "Unknown error";
  // console.log("===handleRequestData===: ", isSucceed, detail, resp);
  return [isSucceed, detail, resp];
};

export { getFuelSuppliers, postCreateNewSupplier, deactivateFuelSupplier, activateFuelSupplier, updateFuelSupplier };